export const LOGGED_IN = "LOGGED_IN";
export const LOGGED_OUT = "LOGGED_OUT";
export const LOGGING_IN = "LOGGING_IN";
export const LOGIN_ERROR = "LOGIN_ERROR";
